export const euColor = "#0047ba";
export const worldColor = "#0099a8";
